import React from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../components/Auth/Login';

function LoginPage() {
  const navigate = useNavigate();

  const handleSwitchToRegister = () => {
    navigate('/register');
  };

  const handleLoginSuccess = () => {
    navigate('/dashboard');
  };

  return (
    <div>
      <Login 
        onSwitchToRegister={handleSwitchToRegister}
        onLoginSuccess={handleLoginSuccess}
      />
    </div>
  );
}

export default LoginPage;